







































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
// @ts-ignore
import Teleport from 'vue2-teleport'

@Component({
  props: {
    size: {
      type: String,
      default: 'md'
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    center: {
      type: Boolean,
      default: false
    },
    outerClose: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    padding: {
      type: String,
      default: '4rem'
    }
  },
  components: { LoaderWrapper, Icon, Teleport }
})
export default class ModalV2 extends Vue {
  scrollOffset: number = 0
  animate: boolean = false

  mounted () {
    this.scrollOffset = window.scrollY
    document.body.style.top = `-${window.scrollY}px`
    document.body.classList.add('modal-opened')
    if (this.$props.outerClose) {
      window.addEventListener('keyup', this.onEsc)
    }

    setTimeout(() => {
      this.animate = true
    }, 150)
  }

  onEsc (e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this.close()
    }
  }

  close () {
    if (this.$props.loading) {
      return
    }

    this.animate = false

    setTimeout(() => {
      this.$emit('close')
    }, 150)
  }

  beforeDestroy () {
    this.animate = false
    document.body.classList.remove('modal-opened')
    document.body.style.top = null
    window.scrollTo({ top: this.scrollOffset })
    if (this.$props.outerClose) {
      window.removeEventListener('keyup', this.onEsc)
    }
  }
}
